module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isExternal(_vm.item.path)) ? _c('router-link', {
    staticClass: "router-link",
    class: {
      'router-link-active': _vm.item.path === _vm.$route.path
    },
    attrs: {
      "to": _vm.item.path,
      "exact": ""
    }
  }, [_vm._v("\n  " + _vm._s(_vm.item.title) + "\n")]) : _c('a', {
    staticClass: "router-link",
    attrs: {
      "href": _vm.item.path,
      "target": "_blank"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.item.title) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7a307ed2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavLink.vue
// module id = 103
// module chunks = 0